import React, { useEffect } from 'react';
import RemoteControllerPanel from '../components/presentationRemote/RemoteControllerPanel';
import { PaidPassGateProvider } from '../contexts/PaidPassGateContext';

/** /remote — 휴대폰 등 단독 탭용 리모컨 */
const RemoteControllerPage: React.FC = () => {
  useEffect(() => {
    const stored = window.localStorage.getItem('curriculum-theme');
    document.documentElement.dataset.theme = stored === 'dark' ? 'dark' : 'light';
  }, []);
  return (
    <PaidPassGateProvider>
      <div className="cp-remote-page">
        <RemoteControllerPanel />
      </div>
    </PaidPassGateProvider>
  );
};

export default RemoteControllerPage;
